import { theme } from 'antd';

const lightTheme = {
  name: 'light',
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#1aa7d7',
    colorSuccess: '#6dca42',
    colorWarning: '#ff8319',
    colorInfo: '#1677ff',
    colorError: '#ff544e',
    colorLink: '#1677ff',
    colorTextBase: '#000000',
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#f9f9f9',
    colorBgElevatedDarker: '#f5f5f5',
    colorBgLayout: '#f5f5f5',
    colorBgPanel: '#f0f0f0', // Insights panel background (light theme equivalent)
    colorBgPanelContainer: 'rgba(0, 0, 0, 0.08)', // Insights panel container background
    colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
    colorBorder: '#d6d6d6',
    colorBorderSecondary: '#ededed',
    fontFamily: 'Heebo',
    fontFamilyCode: 'Heebo',
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
    colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
    colorTextQuaternary: 'rgba(0, 0, 0, 0.25)',
    colorTextLightSolid: '#ffffff',
    colorTextHeading: 'rgba(0, 0, 0, 0.88)',
    colorTextLabel: 'rgba(0, 0, 0, 0.65)',
    previewOperationColor: 'rgba(255, 255, 255, 0.65)',
    previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
    previewOperationColorBg: 'rgba(0, 0, 0, 0.1)',
    previewTextColor: 'rgba(255, 255, 255, 0.85)',
    previewBackgroundColor: 'rgba(0, 0, 0, 0.75)',
    carouselOutsetArrowColor: 'rgba(0, 0, 0, 0.45)',
    carouselOutsetArrowColorBg: 'rgba(0, 0, 0, 0.1)',
    carouselInsetArrowColor: 'rgba(255, 255, 255, 0.65)',
    carouselInsetArrowColorBg: 'rgba(0, 0, 0, 0.1)',
    colorTextDescription: 'rgba(0, 0, 0, 0.45)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
    colorIcon: 'rgba(0, 0, 0, 0.45)',
    colorIconHover: 'rgba(0, 0, 0, 0.88)',
    colorFill: 'rgba(0, 0, 0, 0.15)',
    colorFillSecondary: 'rgba(0, 0, 0, 0.06)',
    colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
    colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
    colorWhite: '#ffffff',
    colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
    colorBgTextActive: 'rgba(0, 0, 0, 0.15)',
    colorBgTextHover: 'rgba(0, 0, 0, 0.06)',
    colorBorderBg: '#ffffff',
    colorFillContent: 'rgba(0, 0, 0, 0.06)',
    colorFillContentHover: 'rgba(0, 0, 0, 0.15)',
    colorFillAlter: 'rgba(0, 0, 0, 0.02)',
    transparent: 'rgba(0, 0, 0, 0)',
    colorSplit: 'rgba(0, 0, 0, 0.06)',
    colorErrorBg: '#fff3f2',
    colorErrorBgHover: '#fff2f0',
    colorErrorBorder: '#ffd1c9',
    colorErrorBorderHover: '#ffaaa1',
    colorErrorHover: '#ff8178',
    colorErrorActive: '#d93838',
    colorErrorTextHover: '#ff8178',
    colorErrorText: '#b71f17',
    colorErrorTextActive: '#d93838',
    colorLinkHover: '#4096ff',
    colorInfoBg: '#e6f4ff',
    colorInfoBgHover: '#bae0ff',
    colorInfoBorder: '#91caff',
    colorInfoBorderHover: '#69b1ff',
    colorInfoHover: '#4096ff',
    colorInfoActive: '#0958d9',
    colorInfoTextHover: '#4096ff',
    colorInfoText: '#1677ff',
    colorInfoTextActive: '#0958d9',
    colorLinkActive: '#0958d9',
    colorPrimaryBg: '#ebfdff',
    colorPrimaryBgHover: '#c2f8ff',
    colorPrimaryBorder: '#97edfc',
    colorPrimaryBorderHover: '#69d7f0',
    colorPrimaryHover: '#40c0e3',
    colorPrimaryActive: '#0c82b0',
    colorPrimaryTextHover: '#40c0e3',
    colorPrimaryText: '#1aa7d7',
    colorPrimaryTextActive: '#0c82b0',
    colorSuccessBg: '#f6ffed',
    colorSuccessBgHover: '#95de64',
    colorSuccessBorder: '#b7eb8f',
    colorSuccessBorderHover: '#95de64',
    colorSuccessHover: '#95de64',
    colorSuccessActive: '#389e0d',
    colorSuccessTextHover: '#73d13d',
    colorSuccessText: '#52c41a',
    colorSuccessTextActive: '#389e0d',
    colorWarningBg: '#fff6e6',
    colorWarningBgHover: '#ffe4bd',
    colorWarningBorder: '#ffd194',
    colorWarningBorderHover: '#ffba6b',
    colorWarningHover: '#ffba6b',
    colorWarningActive: '#ad5c17',
    colorWarningTextHover: '#d9640b',
    colorWarningText: '#ad5c17',
    colorWarningTextActive: '#ad5c17',
    colorErrorOutline: 'rgba(255, 84, 78, 0.06)',
    colorWarningOutline: 'rgba(221, 153, 102, 0.1)',
    controlItemBgActive: '#e6f4ff',
    controlItemBgActiveDisabled: 'rgba(0, 0, 0, 0.15)',
    controlItemBgActiveHover: '#bae0ff',
    controlItemBgHover: 'rgba(0, 0, 0, 0.04)',
    controlOutline: 'rgba(5, 145, 255, 0.1)',
    controlTmpOutline: 'rgba(0, 0, 0, 0.02)',
    colorFillAlterSolid: '#fafafa',
    fontWeightNormal: 400,
    imageTagFontSizeSM: 14.4,
    imageTagFontSize: 16,
    imagePreviewToolbarFontSize: 20,
    colorFilledHandleBg: '#f0f0f0',
    colorBgSolid: '#000000',
    colorBgSolidActive: 'rgba(0, 0, 0, 0.95)',
    colorBgSolidHover: 'rgba(0, 0, 0, 0.75)',
    solidTextColor: '#ffffff',
    colorMagenta: '#eb2f96',
    colorMagentaBg: '#fff0f6',
    colorMagentaBgHover: '#ffd6e7',
    colorMagentaBorder: '#ffadd2',
    colorMagentaBorderHover: '#ff85c0',
    colorMagentaHover: '#f759ab',
    colorMagentaActive: '#9e1068',
    colorMagentaTextHover: '#f759ab',
    colorMagentaText: '#eb2f96',
    colorMagentaTextActive: '#9e1068',
    colorYellow: '#fadb14',
    colorYellowBg: '#feffe6',
    colorYellowBgHover: '#ffffb8',
    colorYellowBorder: '#fffb8f',
    colorYellowBorderHover: '#fff566',
    colorYellowHover: '#ffec3d',
    colorYellowActive: '#ad8b00',
    colorYellowTextHover: '#ffec3d',
    colorYellowText: '#fadb14',
    colorYellowTextActive: '#ad8b00',
    colorCyan: '#13c2c2',
    colorCyanBg: '#e6fffb',
    colorCyanBgHover: '#b5f5ec',
    colorCyanBorder: '#87e8de',
    colorCyanBorderHover: '#5cdbd3',
    colorCyanHover: '#36cfc9',
    colorCyanActive: '#006d75',
    colorCyanTextHover: '#36cfc9',
    colorCyanText: '#13c2c2',
    colorCyanTextActive: '#08979c',
    colorGeekBlue: '#2f54eb',
    colorGeekBlueBg: '#f0f5ff',
    colorGeekBlueBgHover: '#d6e4ff',
    colorGeekBlueBorder: '#adc6ff',
    colorGeekBlueBorderHover: '#85a5ff',
    colorGeekBlueHover: '#597ef7',
    colorGeekBlueActive: '#1d39c4',
    colorGeekBlueTextHover: '#597ef7',
    colorGeekBlueText: '#2f54eb',
    colorGeekBlueTextActive: '#1d39c4',
    colorLime: '#a0d911',
    colorLimeBg: '#fcffe6',
    colorLimeBgHover: '#f4ffb8',
    colorLimeBorder: '#eaff8f',
    colorLimeBorderHover: '#d3f261',
    colorLimeHover: '#bae637',
    colorLimeActive: '#5b8c00',
    colorLimeTextHover: '#bae637',
    colorLimeText: '#a0d911',
    colorLimeTextActive: '#7cb305',
    colorPurple: '#722ed1',
    colorPurpleBg: '#f9f0ff',
    colorPurpleBgHover: '#efdbff',
    colorPurpleBorder: '#d3adf7',
    colorPurpleBorderHover: '#b37feb',
    colorPurpleHover: '#9254de',
    colorPurpleActive: '#391085',
    colorPurpleTextHover: '#9254de',
    colorPurpleText: '#722ed1',
    colorPurpleTextActive: '#531dab',
    colorGold: '#faad14',
    colorGoldBg: '#fffbe6',
    colorGoldBgHover: '#fff1b8',
    colorGoldBorder: '#ffe58f',
    colorGoldBorderHover: '#ffd666',
    colorGoldHover: '#ffc53d',
    colorGoldActive: '#d48806',
    colorGoldTextHover: '#ffc53d',
    colorGoldText: '#faad14',
    colorGoldTextActive: '#d48806',
    colorVolcano: '#fa541c',
    colorVolcanoBg: '#fff2e8',
    colorVolcanoBgHover: '#ffd8bf',
    colorVolcanoBorder: '#ffbb96',
    colorVolcanoBorderHover: '#ff9c6e',
    colorVolcanoHover: '#ff7a45',
    colorVolcanoActive: '#d4380d',
    colorVolcanoTextHover: '#ff7a45',
    colorVolcanoText: '#fa541c',
    colorVolcanoTextActive: '#d4380d',
    colorIR: '#f04437',
    colorIRBg: '#fff3f2',
    colorIRoBgHover: '#ffe4e2',
    colorIRBorder: '#ffb9b3',
    colorIRBorderHover: '#ff918a',
    colorIRHover: '#e0251b',
    colorIRActive: '#b71f17',
    colorIRTextHover: '#e0251b',
    colorIRText: '#f04437',
    colorIRTextActive: '#b71f17',
    colorAzure: '#4cd3f5',
    colorAzureBg: '#143a52',
    colorAzureBgHover: '#185a77',
    colorAzureBorder: '#1b7a9d',
    colorAzureBorderHover: '#1393c2',
    colorAzureHover: '#1393c2',
    colorAzureActive: '#1393c2',
    colorAzureTextHover: '#1393c2',
    colorAzureText: '#4cd3f5',
    colorAzureTextActive: '#1393c2',
    CompairAssure: {
      colorPrimary: '#0E2954',
      colorSecondary: '#ffffff',
    },
    GDPlatinumColor: '#898C8E',
    Ecoplant_Compressor: {
      headerHeight: 58,
      headerBg: '#ffffff',
      headerFontSize: 16,
      headerFontSizeSM: 14,
      fontHeight: 22,
      fontSize: 14,
      lineHeight: 1.5714285714285714,
      lineWidth: 1,
      fontFamily: 'Heebo',
      fontWeightStrong: 600,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 32,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineHeightLG: 1.5,
      borderRadiusLG: 8,
      colorTextHeading: 'rgba(0, 0, 0, 0.88)',
      colorTextDescription: 'rgba(0, 0, 0, 0.45)',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorPrimary: '#1aa7d7',
      colorFillAlter: 'rgba(0, 0, 0, 0.02)',
      colorBorderSecondary: '#ededed',
      colorBgContainer: '#ffffff',
      fontWeight: 400,
      colorStatusbar: '#ffffff',
      colorBGMaintenance: '#fff6e6',
      colorBGStopped: '#fff3f2',
      colorBGPackagecare: '#d93838',
      'colorBGmissing spec': '#ebfdff',
      colorBGSelected: '#e6f4ff',
      onePxSize: 1,
    },
    Ecoplant_Charts: {
      dotSize: 12,
      indicatorHeightSM: 14,
      textFontSizeXXL: 38,
      textFontSizeSM: 18,
      colorWarning: '#ff8319',
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
      colorTextLightSolid: '#ffffff',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorSuccess: '#6dca42',
      colorPrimary: '#1aa7d7',
      colorErrorHover: '#ff8178',
      colorError: '#ff544e',
      colorInlineBorder: '#ededed',
      colorBgContainer: '#ffffff',
      fontFamily: 'Heebo',
      textFontSizeXL: 24,
      textFontSizeLG: 16,
      colorBorder: '#d6d6d6',
      colorBgElevated: '#f9f9f9',
      colorBgElevatedDarker: '#f5f5f5',
      colorEnergyDay: '#2f54eb',
      colorEnergyMonth: '#36cfc9',
      colorEnergyYear: '#4096ff',
      colorWarningLight: '#ffba6b',
      colorActualenergy: '#36cfc9',
      colorBaseline: '#2f54eb',
      colorSpecificPowerValue: '#4096ff',
      colorOldProductionfloor: '#1aa7d7',
      colorOldProductionfloorWaist: '#97edfc',
      colorOldProductionfloorProduction: '#69d7f0',
      colorNewProductionfloor: '#36cfc9',
      colorNewProductionfloorWaist: '#13c2c2',
      colorNewProductionfloorProduction: '#08979c',
      colorSystemProductionfloor: '#597ef7',
      colorSystemProductionfloorWaist: '#2f54eb',
      colorSystemProductionfloorProduction: '#1d39c4',
      colorInsightsRisk: '#ff544e',
      colorInsightsEnergy: '#52c41a',
      colorInsightsMaintenance: '#ff8319',
      colorLinechart_1: '#1677ff',
      colorLinechart_2: '#faad14',
      colorLinechart_3: '#722ed1',
      colorLinechart_4: '#a0d911',
      colorLinechart_5: '#fa541c',
      colorLinechart_6: '#1aa7d7',
      colorLinechart_7: '#fadb14',
      colorLinechart_8: '#eb2f96',
      colorLinechart_9: '#13c2c2',
      colorLinechart_10: '#2f54eb',
      colorChartsLines: 'rgba(0, 0, 0, 0.06)',
    },
  },
  components: {
    Menu: {
      activeBarBorderWidth: 0,
      itemBg: '#f9f9f9',
      colorPrimary: '#1aa7d7',
      itemSelectedColor: 'rgba(0, 0, 0, 0.88)',
    },
    Button: {
      colorLink: '#1aa7d7',
      colorLinkHover: '#40c0e3',
      colorLinkActive: '#40c0e3',
      primaryColor: 'rgba(0,0,0,0.88)',
    },
    Skeleton: {
      paragraphLiHeight: 40,
    },
    Drawer: {
      padding: 0,
      paddingLG: 0,
      paddingXS: 0,
    },
    Tabs: {
      horizontalItemPadding: '12px 12px',
    },
    Card: {
      colorBgContainer: '#f9f9f9',
      colorBorderSecondary: '#d6d6d6',
    },
    Collapse: {
      headerBg: '#f9f9f9',
      contentBg: '#f9f9f9',
      contentPadding: 4,
    },
    Tag: {
      defaultBg: 'rgba(255, 255, 255, 0.04)',
    },
  },
};

export default lightTheme;
